module.exports = __webpack_public_path__ + "media/images/features/draft/eyecatch-flow-05-fda38dd38a1cf6ef9a5e2ba7060e302b.png";